import { useNavigate, useLocation, useParams } from 'react-router-dom';

export function withHOCSRouter(Component) {
  return (props) => (
    <Component {...props} navigate={useNavigate()} location={useLocation()} params={useParams()} />
  );
}
